import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { UserCogIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/users/admin')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="userManagement.adminStaffs.crumb.adminStaffs" icon={UserCogIcon} />,
      title: <Translation id="userManagement.adminStaffs.crumb.adminStaffs" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
